import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';

import { IconComponent } from '@mode/capra';
import { ReportTypes } from '@mode/shared/contract-common';
import { SharedUtilSegmentModule } from '@mode/shared/util-segment';

@Component({
  standalone: true,
  selector: 'mode-report-creation-menu-item',
  imports: [CommonModule, IconComponent, MatLegacyMenuModule, SharedUtilSegmentModule],
  templateUrl: './report-creation-menu-item.component.html',
  styleUrls: ['./report-creation-menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportCreationMenuItemComponent {
  @Input() item: ReportTypes.ReportCreationMenuItem | undefined;
  @Output() clicked = new EventEmitter<MouseEvent>();
}
